// extracted by mini-css-extract-plugin
export default {"container":"z3-z","heading":"A3-z","links":"B3-z","copy":"C3-z","subCopy":"D3-z","linksLeft":"E3-z","linksCenter":"F3-z","linksRight":"G3-z","link":"H3-z","onlyLink":"I3-z"};